import { CreatorPromptCard } from "@/components/Feed/CreatorPromptCard";
import { HOMEPAGE_SEED_PROMPTS } from "@/data/homepage-seed";

export function ProductShowcase() {
  return (
    <div className="w-full rounded-xl overflow-hidden border border-tps bg-tps-surface shadow-2xl relative">
      {/* Browser Frame Top Bar */}
      <div className="h-10 bg-[#06010E] border-b border-tps flex items-center px-4 gap-2 sticky top-0 z-10">
        <div className="flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-white/20" />
          <div className="w-3 h-3 rounded-full bg-white/20" />
          <div className="w-3 h-3 rounded-full bg-white/20" />
        </div>
        <div className="mx-auto bg-white/5 rounded-md h-6 w-1/3 flex items-center justify-center">
          <span className="text-[10px] text-white/30 font-mono tracking-wider">thepromptspace.com/prompts</span>
        </div>
      </div>

      {/* Content Area */}
      <div className="p-4 sm:p-6 lg:p-8 bg-tps-surface">
        {/* Mock Filter Bar */}
        <div className="flex items-center justify-between mb-6 pb-4 border-b border-tps">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-tps-primary">Trending Prompts</span>
            <span className="text-xs text-tps-ghost ml-2 hidden sm:inline-block">Ranked by GEO</span>
          </div>
          <div className="flex gap-2">
            <div className="h-8 px-3 rounded-md bg-white/5 border border-tps flex items-center text-xs text-tps-secondary">
              All Intents
            </div>
            <div className="h-8 px-3 rounded-md bg-white/5 border border-tps flex items-center text-xs text-tps-secondary hidden sm:flex">
              Latest
            </div>
          </div>
        </div>

        {/* Prompt Grid with Staggered Reveal */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {HOMEPAGE_SEED_PROMPTS.map((prompt, index) => (
            <div 
              key={prompt.id} 
              className="reveal-on-scroll relative group"
              style={{ transitionDelay: `${150 + index * 100}ms` }}
            >
              {/* Annotation Callouts - appearing on hover to explain the UI */}
              <div className="absolute -top-3 -right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 pointer-events-none hidden sm:block">
                <div className="glass-surface px-2.5 py-1.5 rounded text-[10px] font-mono text-brand-cyan whitespace-nowrap shadow-lg">
                  GEO Score
                </div>
                <div className="absolute top-full right-4 w-px h-4 bg-brand-cyan/50" />
              </div>
              
              <div className="absolute -bottom-3 -left-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 pointer-events-none hidden sm:block">
                <div className="glass-surface px-2.5 py-1.5 rounded text-[10px] font-mono text-tps-secondary whitespace-nowrap shadow-lg">
                  Real Performance Data
                </div>
                <div className="absolute bottom-full left-4 w-px h-4 bg-white/20" />
              </div>

              <CreatorPromptCard prompt={prompt} />
            </div>
          ))}
        </div>
        
        <div className="mt-8 text-center reveal-on-scroll" style={{ transitionDelay: "450ms" }}>
          <p className="text-sm text-tps-tertiary">
            Every prompt is scored by GEO. Every creator builds a portfolio.
          </p>
        </div>
      </div>
    </div>
  );
}
